var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7046 17.1252C21.2073 18.2447 20.8344 18.8666 20.2129 19.8617C19.2184 21.2299 17.9753 23.0957 16.235 23.0957C15.4892 23.0957 15.1162 22.9713 14.619 22.7225C13.9975 22.4737 13.5002 22.225 12.3815 22.225C11.387 22.225 10.7655 22.4737 10.1439 22.7225C9.6467 22.8469 9.27382 23.0957 8.52797 23.0957C6.91197 23.0957 5.66889 21.4787 4.55012 19.9861C1.93965 16.0058 1.69103 11.1548 3.30704 8.66716C4.42581 6.8014 6.29043 5.80634 8.03074 5.80634C8.90085 5.80634 9.64661 6.05508 10.3924 6.30383L10.3925 6.30387C11.1384 6.55264 11.6356 6.8014 12.3815 6.8014C13.003 6.8014 13.5002 6.67702 14.1218 6.42825C14.8676 6.17949 15.6135 5.93072 16.7323 5.93072C18.3483 5.93072 19.9643 6.67702 21.083 8.16962C17.2295 10.1598 17.851 15.6326 21.7046 17.1252Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0167 1C15.7956 2.92329 14.4677 5.4961 12.0876 4.99133C11.4523 2.95096 12.6146 1 15.0167 1Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.95938a8cf1b197a18eb0354439202e3d.svg";
export { ForwardRef as ReactComponent };